import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SpVersionRoutingModule } from './sp-version-routing.module';
import { SpVersionComponent } from './sp-version.component';

@NgModule({
  imports: [
    CommonModule,
    SpVersionRoutingModule
  ],
  declarations: [
    SpVersionComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ]
})
export class SpVersionModule { }
